/*
 * rheincool — Produktvergleich mit Theme-Mitteln (HANDOFF.md §17: keine App)
 * Checkbox auf der Produktkarte → localStorage (max. 3 Handles) →
 * untere Vergleichsleiste → Overlay mit Spec-Tabelle. Die Produktdaten
 * kommen per Fetch von /products/{handle}.js + gerenderten data-Attributen.
 */
(() => {
  'use strict';

  const STORAGE_KEY = 'rc-compare';
  const MAX_ITEMS = 3;

  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  };
  const write = (items) => localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

  const bar = document.querySelector('[data-compare-bar]');
  if (!bar) return;
  const list = bar.querySelector('[data-compare-list]');
  const countEl = bar.querySelector('[data-compare-count]');
  const openBtn = bar.querySelector('[data-compare-open]');
  const clearBtn = bar.querySelector('[data-compare-clear]');
  const overlay = document.querySelector('[data-compare-overlay]');

  const sync = () => {
    const items = read();
    document.querySelectorAll('[data-compare-toggle]').forEach((box) => {
      box.checked = items.some((i) => i.handle === box.dataset.handle);
    });
    bar.hidden = items.length === 0;
    if (countEl) countEl.textContent = items.length;
    if (list) {
      list.innerHTML = '';
      items.forEach((item) => {
        const chip = document.createElement('span');
        chip.className = 'rc-compare__chip';
        chip.textContent = item.title;
        list.appendChild(chip);
      });
    }
    if (openBtn) openBtn.disabled = items.length < 2;
  };

  document.addEventListener('change', (event) => {
    const box = event.target.closest('[data-compare-toggle]');
    if (!box) return;
    let items = read();
    if (box.checked) {
      if (items.length >= MAX_ITEMS) {
        box.checked = false;
        return;
      }
      items.push({ handle: box.dataset.handle, title: box.dataset.title });
    } else {
      items = items.filter((i) => i.handle !== box.dataset.handle);
    }
    write(items);
    sync();
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      write([]);
      sync();
    });
  }

  if (openBtn && overlay) {
    openBtn.addEventListener('click', async () => {
      const items = read();
      const products = await Promise.all(
        items.map((i) =>
          fetch(`/products/${i.handle}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)
        )
      );
      renderOverlay(products.filter(Boolean));
      overlay.hidden = false;
      document.body.classList.add('rc-no-scroll');
      overlay.querySelector('button')?.focus();
    });

    overlay.addEventListener('click', (event) => {
      if (event.target.matches('[data-compare-close]')) closeOverlay();
    });
    overlay.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeOverlay();
    });
  }

  const closeOverlay = () => {
    overlay.hidden = true;
    document.body.classList.remove('rc-no-scroll');
    if (openBtn) openBtn.focus();
  };

  const formatMoney = (cents) => {
    const euros = Math.floor(cents / 100);
    const rest = cents % 100;
    const grouped = new Intl.NumberFormat('de-DE').format(euros);
    return rest === 0 ? `${grouped},– €` : `${grouped},${String(rest).padStart(2, '0')} €`;
  };

  const strings = JSON.parse(document.getElementById('rc-compare-strings')?.textContent || '{}');

  const renderOverlay = (products) => {
    const tableWrap = overlay.querySelector('[data-compare-table]');
    if (!tableWrap) return;
    const rows = [
      { label: strings.price || 'Preis', get: (p) => formatMoney(p.price) },
      { label: strings.title || 'Modell', get: (p) => p.title },
    ];
    let html = '<div class="rc-compare__scroll"><table class="rc-compare__table"><caption class="visually-hidden">' + (strings.caption || 'Produktvergleich') + '</caption><thead><tr><th scope="col"></th>';
    products.forEach((p) => {
      const img = p.featured_image ? `<img src="${p.featured_image}&width=200" alt="" width="100" loading="lazy">` : '';
      html += `<th scope="col"><a href="/products/${p.handle}">${img}<span>${p.title}</span></a></th>`;
    });
    html += '</tr></thead><tbody>';
    rows.forEach((row) => {
      html += `<tr><th scope="row">${row.label}</th>`;
      products.forEach((p) => {
        html += `<td class="rc-num">${row.get(p)}</td>`;
      });
      html += '</tr>';
    });
    html += '</tbody></table></div>';
    tableWrap.innerHTML = html;
  };

  // PDP-Aktionsleiste (product-actions.js) ändert den Storage im selben Tab
  document.addEventListener('rc:compare-change', sync);

  sync();
})();
